webpackJsonp([30],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_utils__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__peiyou_xesencrypt_dist__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__peiyou_xesencrypt_dist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__peiyou_xesencrypt_dist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_util_config__ = __webpack_require__(140);






// 创建axios实例
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

// request拦截器
service.interceptors.request.use(function (config) {
  config.baseURL = location.origin;
  config.headers['timestamp'] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_utils__["a" /* getNowTime */])();
  config.headers['algorithm'] = 'HmacSHA1';
  config.headers['accessid'] = __WEBPACK_IMPORTED_MODULE_4__common_util_config__["a" /* DC_APP_ID_SECREAT */].APP_ID;
  config.headers['sign'] = __WEBPACK_IMPORTED_MODULE_3__peiyou_xesencrypt_dist___default.a.sign(config, __WEBPACK_IMPORTED_MODULE_4__common_util_config__["a" /* DC_APP_ID_SECREAT */].APP_SECREAT);
  return config;
}, function (error) {
  console.log(error);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
  // 校对当前时间
  if (response.headers.currentservertime) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_utils__["b" /* proofTime */])(response.headers.currentservertime);
  }
  return response;
}, function (error) {
  if (error.response && error.response.headers && error.response.headers.currentservertime) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_utils__["b" /* proofTime */])(error.response.headers.currentservertime);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAndroid; });
/* unused harmony export isIphone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thirdParty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWechat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isSpeiyouApp; });
/* unused harmony export errorImg */
/* unused harmony export getWxtoken */
/* unused harmony export clearCookie */
/* unused harmony export getThirdParty */
/* unused harmony export px2px */
/* unused harmony export getRandom */
/* harmony export (immutable) */ __webpack_exports__["h"] = valideName;
/* harmony export (immutable) */ __webpack_exports__["g"] = validePhone;
/* harmony export (immutable) */ __webpack_exports__["f"] = valideMail;
/* unused harmony export cutHeadImg */
/* unused harmony export dateFilter */
/* unused harmony export toDate */
/* unused harmony export isArray */
/* harmony export (immutable) */ __webpack_exports__["e"] = sToHHMM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cookie_js__ = __webpack_require__(42);



var isAndroid = /android/gi.test(navigator.appVersion);
var isIphone = /iphone/gi.test(navigator.appVersion);
var thirdParty = getThirdParty();
// isWechat
var isWechat = /micromessenger/.test(navigator.userAgent.toLowerCase()) ? true : false;
var isSpeiyouApp = /xesapp/.test(navigator.userAgent.toLowerCase()) ? true : false;
// 图片加载失败
function errorImg(img) {
    img.src = "";
    img.onerror = null;
}

// 获取微信分享token
function getWxtoken() {
    if (isWechat) {
        var config = {
            url: '/jsapi'
        };
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__request_js__["a" /* request */])(config);
    }
}

function clearCookie(item) {
    __WEBPACK_IMPORTED_MODULE_1__cookie_js__["a" /* default */].set(item, '', {
        expires: 0,
        path: '/'
    });
}

// 同步获取环境参数
function getThirdParty() {
    var thirdParty = '';
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        thirdParty = 'wechat';
    } else {}
    return thirdParty;
}

/**
 * [px2px 750pxUE图下对应的px值转换为实际设备下展示的px值]
 * @param  {[number]} px    [750px下对应的px值]
 * @param  {[number]} base = 75            [默认基于750px进行转换]
 * @return {[number]}       [实际展示的px值]
 */
function px2px(px) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 75;

    return fxtflex.rem2px(fxtflex.px2rem(px, base));
};

/**
 * [getRandom 获取【0，length-1)]之间的整数随机数
 * @param  {[number]} length: 2             [随机数个数]
 * @return {[number]}         [整数随机数，默认返回0或1]
 */
function getRandom(length) {
    return Math.floor(Math.random() * length);
};
/**
 * [valideName 验证姓名长度]
 * @param  {[string]} val    [name 字串]
 * @param  {[number]} length [限制长度]
 * @return {[boolean]}        [Boolean]
 */
function valideName(val, length) {
    if (val) {
        if (val.length > length) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}
/**
 * [validePhone 常规手机号验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
function validePhone(val) {
    var reg = /(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/;
    return reg.test(val);
}
/**
 * [valideMail 常规邮箱验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
function valideMail(val) {
    var reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
    return reg.test(val);
}
/**
 * [cutHeadImg 头像阿里云方图裁剪]
 * @param  {[string]} url [用户头像]
 * @return {[string]}     [加入裁剪参数的url]
 */
function cutHeadImg(obj) {
    obj.width = obj.width ? obj.width : 100;
    obj.height = obj.height ? obj.height : 100;
    if (obj.url) {
        if (obj.url.indexOf('?') >= 0) {
            // & 拼接
            if (obj.url.indexOf('x-oss-process=image/resize,m_fill' >= 0)) {
                return obj.url;
            }
            return obj.url + '&x-oss-process=image/resize,m_fill,h_' + obj.height + ',w_' + obj.width;
        } else {
            // ? 拼接
            return obj.url + '?x-oss-process=image/resize,m_fill,h_' + obj.height + ',w_' + obj.width;
        }
    }
    return '';
}
// dateFilter for js stamp
function dateFilter(value, fmt) {
    if (value) {
        var date = new Date(value);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return fmt;
    } else {
        return '   -';
    }
}

/**
 * [时间戳转换为时间]
 * @param  {[String]} timeStamp [以毫秒为单位]
 * @return {[Array]}           [年，月，日，时，分，秒]
 */
function toDate(timeStamp) {
    var currentDate = new Date(Number(timeStamp));
    var currentTime = currentDate.getTime();
    var currentHour = currentDate.getHours();
    var currentMinute = currentDate.getMinutes();
    var currentSeconds = currentDate.getSeconds();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentDay = currentDate.getDate();
    return [currentYear, currentMonth + 1, currentDay, currentHour, currentMinute, currentSeconds];
}

/**
 * [判断是否为数组]
 * @param  {[Object]} obj  任意对象 数组、字符串，对象等
 * @return {[Boolean]}
 */
function isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
}

function sToHHMM(t) {
    if (!t) {
        return '';
    }
    var h = parseInt(t / 3600);
    var s = parseInt(t % 3600 / 60);
    return (h > 9 ? h : '0' + h) + ':' + (s > 9 ? s : '0' + s);
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var settings = {
    url: '',
    timeout: 60000,
    method: 'get',
    baseURL: '',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    params: {},
    transformResponse: [function (data) {
        // Do whatever you want to transform the data
        return data;
    }],
    withCredentials: false, // default
    responseType: 'json' // default

};
function request(data) {
    var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(settings, data);
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.request(config);
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(109)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _isValidKey = function _isValidKey(key) {
    return new RegExp("^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$").test(key);
};

var getRaw = function getRaw(key) {
    if (_isValidKey(key)) {
        var reg = new RegExp("(^| )" + key + "=([^;]*)(;|\x24)"),
            result = reg.exec(document.cookie);

        if (result) {
            return result[2] || null;
        }
    }

    return null;
};

var get = function get(key) {
    var value = getRaw(key);
    if ('string' == typeof value) {
        value = decodeURIComponent(value);
        return value;
    }
    return null;
};

var setRaw = function setRaw(key, value, options) {
    if (!_isValidKey(key)) {
        return;
    }

    options = options || {};

    // 计算cookie过期时间
    var expires = options.expires;
    if ('number' == typeof options.expires) {
        expires = new Date();
        expires.setTime(expires.getTime() + options.expires);
    }

    document.cookie = key + "=" + value + (options.path ? "; path=" + options.path : "") + (expires ? "; expires=" + expires.toGMTString() : "") + (options.domain ? "; domain=" + options.domain : "") + (options.secure ? "; secure" : '');
};

var remove = function remove(key, options) {
    options = optionalions || {};
    options.expires = new Date(0);
    setRaw(key, '', options);
};

var set = function set(key, value, options) {
    setRaw(key, encodeURIComponent(value), options);
};
var Cookie = {};
/* harmony default export */ __webpack_exports__["a"] = ({
    getRaw: getRaw,
    get: get,
    remove: remove,
    setRaw: setRaw,
    set: set
});

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    url: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    provinces: '', // 省市信息
    provincesIdMap: {}, // 省id map
    citysIdMap: {}, // 市id map
    grades: '' // 年级信息
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    "is_new": true,
    "user_state": 0, // 0 未关注，1已关注
    "name": "", //孩子姓名
    "headimg": "", // 头像
    "phone": "", //家长手机号 
    "phone_code": "",
    "province_id": "", //省份id，获取省份和城市见/wechat/api/city接口 
    "province_name": "",
    "city_id": "", //城市id
    "city_name": "",
    "area_code": "",
    "sex": "", //性别 1男 2女 
    "grade": "", //在读年级 
    "email": "", //邮箱 
    "uid": "", //培优账号（如有）
    "stu_num": "", // 学员编号
    "birth": "", //生日
    "py_area_code": "", //培优地区码
    "py_area_name": "", //配有地区名称
    "py_real_name": "", //培优真实姓名
    "py_grade": "", //培优年级
    "stu_id": "",
    "state": "", //是否关注公众号
    "is_complete": false // 是否绑定信息
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    id: '',
    openId: '', // wx openid
    token: '', // wx token
    wxname: '',
    wxnickName: '',
    wxavatar: '',
    wxemail: '',
    wxsex: '',
    wxcity: '',
    wxprovince: '',
    wxcountry: '',
    appId: ''
};
/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = offLineLister;
/* unused harmony export connectNetType */
/* unused harmony export wxNetType */
/* unused harmony export netTypeChange */
/* unused harmony export isOnline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);



var setting = {
    type: '', // 网络类型
    connect: window.navigator.connection || null,
    ua: window.navigator.userAgent,
    isOnline: window.navigator.onLine,
    offLineHanler: function offLineHanler() {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您目前处于无网络状态，请检查网络！');
    },
    typeChangeHandler: function typeChangeHandler() {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您的网络有变化~');
    }
};
function offLineLister() {
    var oldOnLineType = window.navigator.onLine;
    if (setting.connect) {
        setting.connect.onchange = function () {
            document.dispatchEvent(new Event('network_change'));
        };
    } else {
        setInterval(function () {
            if (oldOnLineType !== window.navigator.onLine) {
                oldOnLineType = window.navigator.onLine;
                document.dispatchEvent(new Event('network_change'));
            }
        }, 2000);
    }
};
function connectNetType() {
    // 只能用于移动设备网络状态检测
    // bluetooth
    // cellular
    // ethernet
    // none
    // wifi
    // other
    // unknown
    var connection = setting.connect;
    if (connection) {
        alert(connection.type);
        return connection.type;
    } else {}
};
function wxNetType() {
    // debugger
    if (/NetType/.test(setting.ua)) {
        var netType = setting.ua.match(/NetType\/(\S*)/);
        if (netType.indexOf('WIFI') >= 0) {
            return 'wifi';
        } else if (netType.indexOf('4G') >= 0) {
            return '4g';
        } else if (netType.indexOf('3G') >= 0) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您当前的网络是3g哦~建议打开WiFi网络录音效果更佳');
            return '3g';
        } else if (netType.indexOf('2G') >= 0) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('您当前的网络是2g哦，建议打开WiFi网络录音效果更佳');
            return '2g';
        } else {
            if (!setting.isOnline) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('网络异常，请检查后重试~');
                return 'none';
            }
        }
    }
    return '';
};
function netTypeChange() {
    setting.connect && setting.connect.addEventListener('ontypechange', function (e) {});
}

function isOnline() {
    return window.navigator.onLine;
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_cookie__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);


// import UnFound from '@/views/Unfound';

// 用户中心-首页
var UserCenter = function UserCenter(r) {
    return __webpack_require__.e/* require.ensure */(27).then((function () {
        return r(__webpack_require__(224));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};;
var UserHome = function UserHome(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(216));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-手机号登录
var UserPhoneLogin = function UserPhoneLogin(r) {
    return __webpack_require__.e/* require.ensure */(12).then((function () {
        return r(__webpack_require__(219));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心作业答案
var Answer = function Answer(r) {
    return __webpack_require__.e/* require.ensure */(17).then((function () {
        return r(__webpack_require__(199));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-学而思账号登录
var UserXesLogin = function UserXesLogin(r) {
    return __webpack_require__.e/* require.ensure */(22).then((function () {
        return r(__webpack_require__(222));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 绑定手机号
var UserBindPhone = function UserBindPhone(r) {
    return __webpack_require__.e/* require.ensure */(13).then((function () {
        return r(__webpack_require__(213));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-完善信息
var CompleteInfo = function CompleteInfo(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__(201));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 用户中心-表单
var UserInfo = function UserInfo(r) {
    return __webpack_require__.e/* require.ensure */(15).then((function () {
        return r(__webpack_require__(217));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//用户中心-表单详细信息
var UserSex = function UserSex(r) {
    return __webpack_require__.e/* require.ensure */(20).then((function () {
        return r(__webpack_require__(220));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserSwitchPhone = function UserSwitchPhone(r) {
    return __webpack_require__.e/* require.ensure */(11).then((function () {
        return r(__webpack_require__(221));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserMail = function UserMail(r) {
    return __webpack_require__.e/* require.ensure */(23).then((function () {
        return r(__webpack_require__(218));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//切换学员编号
var SwitchStuNum = function SwitchStuNum(r) {
    return __webpack_require__.e/* require.ensure */(24).then((function () {
        return r(__webpack_require__(211));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//资料下载
var UserDocument = function UserDocument(r) {
    return __webpack_require__.e/* require.ensure */(14).then((function () {
        return r(__webpack_require__(214));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UserDownload = function UserDownload(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(215));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DownloadSelect = function DownloadSelect(r) {
    return __webpack_require__.e/* require.ensure */(16).then((function () {
        return r(__webpack_require__(203));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DocQrCode = function DocQrCode(r) {
    return __webpack_require__.e/* require.ensure */(18).then((function () {
        return r(__webpack_require__(202));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//考试
var ExamCard = function ExamCard(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__(204));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamInfo = function ExamInfo(r) {
    return __webpack_require__.e/* require.ensure */(9).then((function () {
        return r(__webpack_require__(205));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamNotice = function ExamNotice(r) {
    return __webpack_require__.e/* require.ensure */(8).then((function () {
        return r(__webpack_require__(206));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ExamQuery = function ExamQuery(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__(207));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ScheduleQuery = function ScheduleQuery(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(210));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ClassList = function ClassList(r) {
    return __webpack_require__.e/* require.ensure */(10).then((function () {
        return r(__webpack_require__(200));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TestList = function TestList(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__(212));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var IfsReport = function IfsReport(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(209));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Follow = function Follow(r) {
    return __webpack_require__.e/* require.ensure */(25).then((function () {
        return r(__webpack_require__(208));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 本地图文
var Imagetext = function Imagetext(r) {
    return __webpack_require__.e/* require.ensure */(28).then((function () {
        return r(__webpack_require__(223));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Wximagetext = function Wximagetext(r) {
    return __webpack_require__.e/* require.ensure */(19).then((function () {
        return r(__webpack_require__(198));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Pcimagetext = function Pcimagetext(r) {
    return __webpack_require__.e/* require.ensure */(26).then((function () {
        return r(__webpack_require__(197));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 微信授权失败公共页面
var Authfail = function Authfail(r) {
    return __webpack_require__.e/* require.ensure */(21).then((function () {
        return r(__webpack_require__(225));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history', // 删除url中的#
    routes: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_3__App___default.a
    },
    // 微信授权失败公共页面
    {
        path: '/authfail',
        component: Authfail,
        meta: {
            title: ''
        },
        beforeEnter: function beforeEnter(to, from, next) {
            document.title = to.meta.title;
            next();
        }
    },
    //PC端二维码
    {
        path: '/docqrcode',
        component: DocQrCode,
        meta: {
            title: '文件二维码'
        },
        beforeEnter: function beforeEnter(to, from, next) {
            document.title = to.meta.title;
            next();
        }
    },
    // 用户中心-首页
    {
        path: '/user',
        component: UserCenter,
        children: [
        // 中心
        {
            path: 'home',
            component: UserHome,
            meta: {
                title: '我的中心'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 手机号登录
        {
            path: 'phonelogin',
            component: UserPhoneLogin,
            meta: {
                title: '手机号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 作业答案
        {
            path: 'answer',
            component: Answer,
            meta: {
                title: '补充材料'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 完善信息
        {
            path: 'compinfo',
            component: CompleteInfo,
            meta: {
                title: '完善信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 学而思账号登录
        {
            path: 'xeslogin',
            component: UserXesLogin,
            meta: {
                title: '学而思账号登录'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 表单
        {
            path: 'info',
            component: UserInfo,
            meta: {
                title: '个人信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //性别
        {
            path: 'sex',
            component: UserSex,
            meta: {
                title: '选择性别'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 切换手机
        {
            path: 'switchphone',
            component: UserSwitchPhone,
            meta: {
                title: '切换手机号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        // 绑定手机
        {
            path: 'bindphone',
            component: UserBindPhone,
            meta: {
                title: '绑定手机号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //邮箱
        {
            path: 'mail',
            component: UserMail,
            meta: {
                title: '填写邮箱'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //切换学员编号
        {
            path: 'stunum',
            component: SwitchStuNum,
            meta: {
                title: '切换学员编号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //我的资料下载
        {
            path: 'document',
            component: UserDocument,
            meta: {
                title: '我的资料'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //素材管理
        {
            path: 'material',
            component: UserDownload,
            meta: {
                title: '资料下载'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        },
        //下载选择
        {
            path: 'select',
            component: DownloadSelect,
            meta: {
                title: '文件详情'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examcard',
            component: ExamCard,
            meta: {
                title: '准考证'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examinfo',
            component: ExamInfo,
            meta: {
                title: '考场信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
            beforeLeave: function beforeLeave(to, from, next) {
                console.log(to);
                console.log(form);
                next();
            }
        }, {
            path: 'examNotice',
            component: ExamNotice,
            meta: {
                title: '考场信息'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'examquery',
            component: ExamQuery,
            meta: {
                title: '考场列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                if (from.fullPath.indexOf('classLIst') > -1) {
                    window.location.href = '/user/examquery';
                } else {
                    next();
                }
            }
        }, {
            path: 'scheduleQuery',
            component: ScheduleQuery,
            meta: {
                title: '课表查询'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'classList',
            component: ClassList,
            meta: {
                title: '课次列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                console.log(from);
                if (from.fullPath.indexOf('gotoWhere=1') > -1) {
                    // this.$router.go('/user/examquery')
                    window.location.href = '/user/examquery';
                } else {
                    next();
                }
                next();
            }
        }, {
            path: 'testlist',
            component: TestList,
            meta: {
                title: '考试列表'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'ifsreport',
            component: IfsReport,
            meta: {
                title: 'IFS成绩报告'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }, {
            path: 'follow',
            component: Follow,
            meta: {
                title: '关注公众号'
            },
            beforeEnter: function beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            }
        }]
    }, {
        path: '/:userCenterId',
        component: UserHome
    },
    // 本地图文
    {
        path: '/pictext',
        component: Imagetext,
        children: [{
            path: 'wximgtext',
            component: Wximagetext
        }, {
            path: 'pcimgtext',
            component: Pcimagetext
        }]
    }]
}));

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_baseUrl__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_wxAuth__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_userInfo__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_provincialGrade__ = __webpack_require__(149);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);




// import habitUserInfo from './modules/habitUserInfo';
// import habitJournal from './modules/habitJournal';
// import habitCard from './modules/habitCard';
// import audioStatus from './modules/audioStatus';
// import lRecordModel from './modules/lRecordModel';
// import hRecordModel from './modules/hRecordModel';
// import lAnswerModel from './modules/lAnswerModel';
// import mAnswerModel from './modules/mAnswerModel';
// import mRecordModel from './modules/mRecordModel';
// import habitLower from './modules/habitLower';
// import habitUserInfoPrev from './modules/habitUserInfoPrev';
// import habitCardPrev from './modules/habitCardPrev';
// // 七大能力
// import sevenAbilityPlayer from './modules/sevenAbilityPlayer';
// import sevenAbilityGames from './modules/sevenAbilityGames';
// import sevenAbilityIntroduce from './modules/sevenAbilityIntroduce';
// // 新年换装2018
// import happyNewYear2018 from './modules/happyNewYear2018'
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        baseUrl: __WEBPACK_IMPORTED_MODULE_2__modules_baseUrl__["a" /* default */],
        wxAuth: __WEBPACK_IMPORTED_MODULE_3__modules_wxAuth__["a" /* default */],
        userInfo: __WEBPACK_IMPORTED_MODULE_4__modules_userInfo__["a" /* default */],
        provincialGrade: __WEBPACK_IMPORTED_MODULE_5__modules_provincialGrade__["a" /* default */]
        // // 21天
        // habitUserInfo,
        // habitJournal,
        // habitCard,
        // audioStatus, // audio 播放状态总线
        // lRecordModel, // low-l1-3-model
        // lAnswerModel, //low-l1-3-answer-model
        // mAnswerModel, // mid L4-6
        // mRecordModel, // mid L4-6
        // habitLower, //low-l1-3
        // hRecordModel, //higher-l7-9-model
        // //21天预览
        // habitUserInfoPrev,
        // habitCardPrev,
        // // 七大能力
        // sevenAbilityPlayer,
        // sevenAbilityGames,
        // sevenAbilityIntroduce,
        // // 新年换装2018
        // happyNewYear2018
    }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    created: function created() {
        var baseUrl = this.$store.state.baseUrl.url;
        if (baseUrl) {
            // 已经赋值
        } else {
            // 需要赋值
            var url = location.href;
            this.$store.dispatch('setBaseUrl', url);
        }
    }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DC_APP_ID_SECREAT; });
function _getEnv() {
  console.log("prod", '---DP_ENV---');
  return "prod" || 'dev';
}
var isGrayProd = ['gray', 'prod'].includes(_getEnv().toLowerCase());
var DC_APP_ID_SECREAT = {
  APP_ID: isGrayProd ? 'efd4168edcce44e5abdeeff63995ab34' : 'bd8d27dedf714161b685f5b40ba73b82',
  APP_SECREAT: isGrayProd ? '9d9c24a77d52457c93c934543688b196' : '8cc34b5293074fe3bd978f205eb03427'
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNowTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return proofTime; });
var getNowTime = function getNowTime() {
  var timestamp = new Date().getTime();
  var pTime = window.localStorage.getItem('proofTime') || 0;
  return parseInt(timestamp, 10) - parseInt(pTime, 10);
};

var proofTime = function proofTime(serverTime) {
  if (!serverTime) return;
  var timestamp = new Date().getTime();
  var time = parseInt(timestamp, 10) - parseInt(serverTime, 10);
  window.localStorage.setItem('proofTime', time);
};



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_message_box_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_infinite_scroll_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_lazyload_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_range_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_switch_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_mint_ui_lib_spinner_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_mint_ui_lib_radio_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_mint_ui_lib_progress_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_mint_ui_lib_popup_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_mint_ui_lib_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_mint_ui_lib_datetime_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_mint_ui_lib_cell_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_mint_ui_lib_actionsheet_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__common_util_fetch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__App__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__router__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__vuex_store__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_event_calendar__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_event_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vue_event_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__assets_style_calendarStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__common_util_network_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__common_util_global__ = __webpack_require__(22);






































__webpack_require__(76).polyfill();




__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default.a.name, __WEBPACK_IMPORTED_MODULE_37_mint_ui_lib_actionsheet___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_35_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default.a.name, __WEBPACK_IMPORTED_MODULE_33_mint_ui_lib_cell___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_31_mint_ui_lib_datetime_picker___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_29_mint_ui_lib_field___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_27_mint_ui_lib_picker___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default.a.name, __WEBPACK_IMPORTED_MODULE_25_mint_ui_lib_popup___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a.name, __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default.a.name, __WEBPACK_IMPORTED_MODULE_21_mint_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default.a.name, __WEBPACK_IMPORTED_MODULE_19_mint_ui_lib_spinner___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default.a.name, __WEBPACK_IMPORTED_MODULE_17_mint_ui_lib_swipe___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default.a.name, __WEBPACK_IMPORTED_MODULE_15_mint_ui_lib_swipe_item___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default.a.name, __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_switch___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a.name, __WEBPACK_IMPORTED_MODULE_23_mint_ui_lib_progress___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default.a.name, __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_range___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_infinite_scroll___default.a);




// import 'vue-event-calendar/dist/style.css';

__WEBPACK_IMPORTED_MODULE_38_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_44_vue_event_calendar___default.a, { locale: 'zh', color: '#fd8b23' });
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_toast___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$messageBox = __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$indicator = __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$axios = __WEBPACK_IMPORTED_MODULE_39__common_util_fetch__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].config.productionTip = false;
// net listener

__WEBPACK_IMPORTED_MODULE_46__common_util_network_js__["a" /* offLineLister */]();

var dateFilter = function dateFilter(value, fmt) {
    if (value) {
        var date = new Date(value * 1000);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }return fmt;
    } else {
        return '   -';
    }
};


__WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_47__common_util_global__["a" /* isAndroid */]) {
        // android 需要每次都赋予当前的值
        __WEBPACK_IMPORTED_MODULE_43__vuex_store__["a" /* default */].state.baseUrl.url = location.origin + to.fullPath;
    }
    next();
});

__WEBPACK_IMPORTED_MODULE_38_vue__["default"].prototype.$dateFilter = dateFilter;
__WEBPACK_IMPORTED_MODULE_38_vue__["default"].filter('dateFilter', dateFilter);

new __WEBPACK_IMPORTED_MODULE_38_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_42__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_43__vuex_store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_41__App___default.a }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
    setBaseUrl: function setBaseUrl(context, data) {
        context.commit('setBaseUrl', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(59);

var getters = {
    getBaseUrl: function getBaseUrl(state) {
        return state.url;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(146);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    setBaseUrl: function setBaseUrl(state, data) {
        // 变更base url
        state.url = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_fetch__ = __webpack_require__(13);





var urls = {
    getProvincial: '/insightH5/remote/userCenter/city',
    getGrade: '/insightH5/h5/gradeList'
};

var actions = {
    getProvincialInfo: function getProvincialInfo(context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_fetch__["a" /* default */])({
            'url': urls.getProvincial
        }).then(function (res) {
            var result = res.data ? res.data : {};
            // data 判断
            if (result.error_code == 0) {
                context.commit('provinceInfo', result.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(result.error_msg || '省市配置信息获取失败！');
            }
            return result;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    getGradeInfo: function getGradeInfo(context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_fetch__["a" /* default */])({
            'url': urls.getGrade
        }).then(function (res) {
            var result = res.data ? res.data : {};
            if (result.error_code == 0) {
                context.commit('gradeInfo', result.data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(result.error_msg || '年级信息获取失败');
            }
            return result;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(60);

var getters = {
    getAllGrade: function getAllGrade(state) {
        return state.grades;
    },
    getProvinces: function getProvinces(state) {
        return state.provinces;
    },
    getProvincesIdMap: function getProvincesIdMap(state) {
        return state.provincesIdMap;
    },
    getCitysIdMap: function getCitysIdMap(state) {
        return state.citysIdMap;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(150);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var mutations = {
    provinceInfo: function provinceInfo(state, data) {
        // 更新信息
        state.provinces = data;
        var cityArrayTemp = [];
        data.map(function (item, index) {
            state.provincesIdMap[item.province_id] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.name);
            // 处理城市
            cityArrayTemp = item.city_list;
            var temp = '';
            cityArrayTemp.map(function (city, index) {
                temp = '' + item.province_id + city.city_id;
                state.citysIdMap[temp] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(city.name);
            });
        });
    },
    gradeInfo: function gradeInfo(state, data) {
        // 更新信息
        state.grades = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_fetch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_request__ = __webpack_require__(29);






var urls = {
    getUserInfo: '/insightH5/remote/userCenter/getUserInfo',
    // regUser: '/wechat/api/register',
    regUser: '/i/wechat/api/userregister',
    updateUser: '/i/wechat/user/updateuserinfo'
};

var actions = {
    getUserInfo: function getUserInfo(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_util_fetch__["a" /* default */])({
            'url': urls.getUserInfo,
            'params': dataObj ? dataObj : {}
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                context.commit('userInit', data);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '获取用户信息失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('服务器走丢了，请稍后重试~');
        });
    },
    userReg: function userReg(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_util_request__["a" /* request */])({
            'url': urls.regUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '操作成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userReg', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '用户注册失败，请稍后重试~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    userUpdate: function userUpdate(context, dataObj) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_util_request__["a" /* request */])({
            'url': urls.updateUser,
            'params': dataObj
        }).then(function (result) {
            var data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('userUpdate', dataObj);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
        });
    },
    updateUName: function updateUName(context, data) {
        context.commit('updateUName', data);
    },
    updateUserImg: function updateUserImg(context, data) {
        context.commit('updateUserImg', data);
    },
    updateSex: function updateSex(context, data) {
        context.commit('updateSex', data);
    },
    updateProvince: function updateProvince(context, data) {
        context.commit('updateProvince', data);
    },
    updateCity: function updateCity(context, data) {
        context.commit('updateCity', data);
    },
    updateProvinceName: function updateProvinceName(context, data) {
        context.commit('updateProvinceName', data);
    },
    updateCityName: function updateCityName(context, data) {
        context.commit('updateCityName', data);
    },
    updateGrade: function updateGrade(context, data) {
        context.commit('updateGrade', data);
    },
    updatePhone: function updatePhone(context, data) {
        context.commit('updatePhone', data);
    },
    updatePhoneCode: function updatePhoneCode(context, data) {
        context.commit('updatePhoneCode', data);
    },
    updateMail: function updateMail(context, data) {
        context.commit('updateMail', data);
    },
    updateBirth: function updateBirth(context, data) {
        context.commit('updateBirth', data);
    },
    updateAreaCode: function updateAreaCode(context, data) {
        context.commit('updateAreaCode', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(61);

var getters = {
    getUserInfoName: function getUserInfoName(state) {
        return state.name;
    },
    getUserSex: function getUserSex(state) {
        return state.sex;
    },
    getUserGrade: function getUserGrade(state) {
        return state.grade;
    },
    getUserMail: function getUserMail(state) {
        return state.email;
    },
    getUserBirth: function getUserBirth(state) {
        return state.birth;
    },
    getUserStuNum: function getUserStuNum(state) {
        return state.stu_num;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(154);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    userInit: function userInit(state, data) {
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
        } else {
            // 不是新用户
            state.is_new = false;
            state.is_complete = data.data.userInfoComplete;
            state.user_state = data.state;
            state.headimg = data.data ? data.data.headPic : '';
            state.name = data.data ? data.data.name : '';
            state.phone = data.data ? data.data.phone : '';
            state.province_id = data.data && data.data.province ? data.data.province.provinceId : '';
            var province_name = data.data && data.data.province ? data.data.province.provinceName : '';
            state.province_name = province_name ? province_name : '';
            state.city_id = data.data && data.data.city ? data.data.city.cityId : '';
            var city_name = data.data && data.data.city ? data.data.city.cityName : '';
            state.city_name = city_name ? city_name : '';
            state.sex = data.data ? data.data.sex : '';
            state.grade = data.data && data.data.grade ? data.data.grade.gradeCode : '';
            state.email = data.data ? data.data.email : '';
            state.uid = data.data ? data.data.uid : '';
            state.stu_num = data.data ? data.data.stuNum : '';
            state.birth = data.birth;
            state.state = data.data.state;
            var area_code = data.data && data.data.city ? data.data.city.areaCode : '';
            state.area_code = area_code ? area_code : '';
            var py_area_code = data.data && data.data.pyData ? data.data.pyData.bindingCode : '';
            state.py_area_code = py_area_code ? py_area_code : ''; //培优地区码
            var py_area_name = data.data && data.data.pyData ? data.data.pyData.cityName : '';
            state.py_area_name = py_area_name ? py_area_name : ''; //培优地区名称
            var py_real_name = data.data && data.data.pyData ? data.data.pyData.realName : '';
            state.py_real_name = py_real_name ? py_real_name : ""; //培优真实姓名
            var py_grade = data.data && data.data.pyData ? data.data.pyData.grid : '';
            state.py_grade = py_grade ? py_grade : ''; //培优年级
            var stu_id = data.data ? data.data.stuId : '';
            state.stu_id = stu_id ? stu_id : '';
        }
    },
    userReg: function userReg(state, data) {
        state.name = data.name;
        state.phone = data.phone;
        state.province_id = data.province_id;
        state.city_id = data.city_id;
        state.sex = data.sex;
        state.grade = data.grade;
        state.email = data.email;
        state.birth = data.birth;
    },
    userUpdate: function userUpdate(state, data) {
        state.name = data.hasOwnProperty('name') ? data.name : state.name;
        state.headimg = data.hasOwnProperty('head_pic') ? data.head_pic : state.headimg;
        state.phone = data.hasOwnProperty('phone') ? data.phone : state.phone;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province_name = data.hasOwnProperty('province_name') ? data.province_name : state.province_name;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.city_name = data.hasOwnProperty('city_name') ? data.city_name : state.city_name;
        state.area_code = data.hasOwnProperty('area_code') ? data.area_code : state.area_code;
        state.sex = data.hasOwnProperty('sex') ? data.sex : state.sex; // 1||2
        state.grade = data.hasOwnProperty('grade') ? data.grade : state.grade;
        state.email = data.hasOwnProperty('email') ? data.email : state.email;
        state.birth = data.hasOwnProperty('birth') ? data.birth : state.birth;
    },
    updateUName: function updateUName(state, data) {
        // 更新用户名
        state.name = data;
    },
    updateUserImg: function updateUserImg(state, data) {
        // 更新用户名
        state.headimg = data;
    },
    updateSex: function updateSex(state, data) {
        // 更新性别
        state.sex = data;
    },
    updateProvince: function updateProvince(state, data) {
        // 更新省份
        state.province_id = data;
    },
    updateCity: function updateCity(state, data) {
        // 更新城市
        state.city_id = data;
    },
    updateProvinceName: function updateProvinceName(state, data) {
        // 更新省份
        state.province_name = data;
    },
    updateCityName: function updateCityName(state, data) {
        // 更新城市
        state.city_name = data;
    },
    updateGrade: function updateGrade(state, data) {
        //更新年级
        state.grade = data;
    },
    updatePhone: function updatePhone(state, data) {
        // 更新手机
        state.phone = data;
    },
    updatePhoneCode: function updatePhoneCode(state, data) {
        state.phone_code = data;
    },
    updateMail: function updateMail(state, data) {
        //更新邮箱
        state.email = data;
    },
    updateBirth: function updateBirth(state, data) {
        //更新生日
        state.birth = data;
    },
    updateAreaCode: function updateAreaCode(state, data) {
        //更新地区码
        state.area_code = data;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_util_global__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_util_fetch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_util_request__ = __webpack_require__(29);







var urls = {
    wxauth: '/insightH5/h5/oauth',
    wxtoken: '/insightH5/h5/jsApi',
    wxauth21Days: '/i/day21/api/oauth',
    wxtoken21Days: '/i/day21/api/jsapi'
};

var actions = {
    wxUserAuth: function wxUserAuth(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["b" /* isWechat */]) {
            // wx 走授权
            var callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = urls.wxauth + '?callbackUrl=' + callback;
        } else {
            return;
        }
    },
    wxToken: function wxToken(context, data) {
        if (!data || !data.url) {
            data = {
                url: window.location.href || ''
            };
        }
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["b" /* isWechat */]) {
            // wx 走授权
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_util_fetch__["a" /* default */])({
                'url': urls.wxtoken,
                'params': data ? data : {}
            }).then(function (result) {
                var data = result.data ? result.data : {};
                // data 判断
                context.commit('wxTokenMutation', data);
                return result;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
            });
        } else {
            return;
        }
    },
    wxUserAuth21Days: function wxUserAuth21Days(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["b" /* isWechat */]) {
            // wx 走授权
            var callback = data.callback_url ? encodeURIComponent(data.callback_url) : '';
            location.href = '/i/day21/api/oauth?callback_url=' + callback;
        } else {
            return;
        }
    },
    wxtoken21Days: function wxtoken21Days(context, data) {
        if (__WEBPACK_IMPORTED_MODULE_2__common_util_global__["b" /* isWechat */]) {
            // wx 走授权
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_util_request__["a" /* request */])({
                'url': urls.wxtoken21Days,
                'params': data ? data : {}
            }).then(function (result) {
                var data = result.data ? result.data : {};
                // data 判断
                context.commit('wxtoken21DaysMutation', data);
                return result;
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()('页面暂时无法访问，请稍后重试！');
            });
        } else {
            return;
        }
    },
    wxTokenMiniapp: function wxTokenMiniapp(context, data) {
        context.commit('wxtokenMiniappMutation', data);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(62);

var getters = {
    getUserId: function getUserId(state) {
        return state.id;
    },
    getOpenId: function getOpenId(state) {
        return state.openId;
    },
    getToken: function getToken(state) {
        return state.token;
    },
    getUserName: function getUserName(state) {
        return state.name;
    },
    getNickName: function getNickName(state) {
        return state.nickName;
    },
    getAvatar: function getAvatar(state) {
        return state.avatar;
    },
    getEmail: function getEmail(state) {
        return state.email;
    },
    getSex: function getSex(state) {
        return state.sex;
    },
    getCity: function getCity(state) {
        return state.city;
    },
    getProvince: function getProvince(state) {
        return state.province;
    },
    getCountry: function getCountry(state) {
        return state.country;
    },
    getWxConf: function getWxConf(state) {
        return state.wxConf;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (getters);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_js__ = __webpack_require__(158);




/* harmony default export */ __webpack_exports__["a"] = ({
    state: __WEBPACK_IMPORTED_MODULE_0__state_js__["a" /* default */],
    getters: __WEBPACK_IMPORTED_MODULE_1__getters_js__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_2__actions_js__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations_js__["a" /* default */]
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    wxUserAuthInfo: function wxUserAuthInfo(state, data) {
        // 变更状态

    },
    wxTokenMutation: function wxTokenMutation(state, data) {
        state.appId = data.appId;
    },
    wxtoken21DaysMutation: function wxtoken21DaysMutation(state, data) {
        state.appId = data.appId;
    },
    wxtokenMiniappMutation: function wxtokenMiniappMutation(state, data) {
        state.appId = data.appId;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(105)(false);
// imports


// module
exports.push([module.i, "body,html{margin:0;padding:0;width:100%;height:100%;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}*{-webkit-text-size-adjust:none;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}input,textarea{-webkit-user-select:auto;margin:0;padding:0;outline:none}#app{margin:0 auto;width:10rem;height:100%;font-family:Microsoft YaHei,arial,helvetica,sans-serif}.mint-msgbox-btn,.mint-msgbox-message,.mint-msgbox-title{font-size:16px}.mint-msgbox{width:80%}.mint-msgbox-btns{height:50px;line-height:50px}.mint-msgbox-btn{padding-top:5px}.mint-msgbox-message{padding:0 5px 8px;color:#333;line-height:1.6}.mint-msgbox-content .mint-msgbox-message{font-size:16px}.mint-msgbox-confirm{color:#46c281}.mint-msgbox{padding-top:12px}.mint-msgbox-cancel,.mint-msgbox-content{border-color:#e4e4e4}.mint-toast{z-index:9999999}.router-view{width:100%;height:100%}", ""]);

// exports


/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(119)("1c7b56d4", content, true, {});

/***/ })
],[142]);


// WEBPACK FOOTER //
// static/js/app.b0e862d6aee1a786e67f.js